import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { IoIosCloseCircleOutline } from "react-icons/io";
import CardDetails from "./card_details";

import { useDispatch, useSelector } from "react-redux";
import { fetchNewsData } from "../../redux/slicer/aluminaiSlicer";
import parse from "html-react-parser";

function News() {
  const dispatch = useDispatch();
  const {
    data: newsData,
    loading,
    error,
  } = useSelector((state) => state.aluminai.news);

  useEffect(() => {
    dispatch(fetchNewsData());
  }, [dispatch]);

  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const openEditPopup = (card) => {
    setSelectedCard(card);
    setIsOpenEdit(true);
  };

  const closeEditPopup = () => {
    setSelectedCard(null);
    setIsOpenEdit(false);
  };

  const [wordLimit, setWordLimit] = useState(30); // Default limit

  useEffect(() => {
    const updateWordLimit = () => {
      if (window.innerWidth < 1280) {
        setWordLimit(15); // Limit to 10 words on sm, md, lg screens
      } else {
        setWordLimit(30); // Default for xl screens and above
      }
    };

    updateWordLimit(); // Set on first render
    window.addEventListener("resize", updateWordLimit); // Listen for resize events

    return () => window.removeEventListener("resize", updateWordLimit);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Settings for react-slick slider
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="container mx-auto p-4">
      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 gap-between">
        {newsData.map((card) => (
          <div
            key={card.alumniNews_id}
            className="rounded shadow-lg bg-white  w-xs  mx-auto h-auto flex flex-col"
          >
            {/* Common Wrapper for Single or Multiple Images */}
            <div className="w-xs h-[30hv]">
              {card.images.length > 1 ? (
                <Slider {...sliderSettings} className="w-xs h-[30hv]">
                  {card.images.map((image, index) => (
                    <div key={index} className="w-xs h-[30hv]">
                      <img
                        src={image}
                        alt={card.alumniNews_title}
                        className="w-full h-[30hv] object-contain rounded-t-lg font-titillium"
                      />
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="w-full h-full">
                  <img
                    src={card.images[0]}
                    alt={card.alumniNews_title}
                    className="w-full h-full object-cover rounded-t-lg"
                  />
                </div>
              )}
            </div>

            <div className="px-6 py-6 flex flex-col justify-between flex-1">
              <div className="font-bold text-primary-color text-justify font-titillium">
                {card.alumniNews_title}
              </div>
              <p className="text-black text-base text-justify md:text-left sm:text-left font-inter">
                {parse(
                  card.alumniNews_description
                    .split(" ")
                    .slice(0, wordLimit)
                    .join(" ") + "..."
                )}
              </p>
              
              <div className="mt-auto pt-2">
                <button
                  onClick={() => openEditPopup(card)}
                  className="flex items-center justify-center text-primary-color"
                >
                  Read More
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isOpenEdit && selectedCard && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg relative max-w-lg w-full">
            <button
              type="button"
              onClick={closeEditPopup}
              className="absolute text-4xl top-4 right-4 text-gray-500 hover:text-black"
            >
              <IoIosCloseCircleOutline />
            </button>
            <CardDetails card={selectedCard} onClose={closeEditPopup} />
          </div>
        </div>
      )}
    </div>
  );
}

export default News;
